var id_current_store = null, url_picture = null, objGeneralInfo = null, objStateInfo = null, objCityInfo = null;

var ddlStates = document.getElementById('ddlState'),
    ddlCities = document.getElementById('ddlCity'),
    ddlEstablishments = document.getElementById('ddlEstablishment'),
    btnSave = document.getElementById('btnSaveBanner'),
    btnCancelSave = document.getElementById('btnCancelSaveBanner');

var layoutCard = `
    <div class="banner-item">
        <div class="banner-item__image">
            <img src="{URL-IMG-BANNER}" alt="">
        </div>
        <div class="banner-item__info">
            <p class="title">{TITLE-BANNER}</p><br/>
            <p class="url">{URL-BANNER}</p>
        </div>
        <div class="banner-item__actions">
            <span class="icon-edit" onclick="editBanner(this);" data-id="{ID-BANNER}" data-type="{TYPE-BANNER}" data-content="{CONTENT-BANNER}" data-picture="{PICTURE-BANNER}" data-title="{TITLE-BANNER}"></span>
            <span class="icon-trash" onclick="deleteBanner(this);" data-id="{ID-BANNER}" data-title="{TITLE-BANNER}"></span>
        </div>
    </div>
`;

document.querySelectorAll('.sidebar-menu-container-section-tab')[2].classList.add('sidebar-menu-container-section-tab--active');
document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';


window.addEventListener("load", loadPage);
ddlStates.addEventListener('change', function (e) {
    document.querySelector('.alerts-container').innerHTML = '';
    document.getElementById('div-banners-added').style = "display:none";
    restoreForm();
    let stateId = this.value;

    if (stateId != "") {
        document.getElementById('divCity').style = "display:flex";
        loadCities(stateId);

        document.getElementById('divEstablishment').style = "display:none";
        ddlEstablishments.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';
    }
    else {
        document.getElementById('divCity').style = "display:none";
    }
});

ddlCities.addEventListener('change', function (e) {
    document.querySelector('.alerts-container').innerHTML = '';
    document.getElementById('div-banners-added').style = "display:none";
    restoreForm();
    let cityId = this.value;

    if (cityId != "") {
        document.getElementById('divEstablishment').style = "display:flex";
        loadBanners(true);
        loadEstablishments(cityId);
    }
    else {
        document.getElementById('divEstablishment').style = "display:none";
    }
});

ddlEstablishments.addEventListener('change', function (e) {
    restoreForm();
});

function restoreForm() {
    btnSave.dataset.id = "0";
    btnSave.innerText = "Generar banner";

    btnCancelSave.classList.add('hide')

    document.querySelector('.menu-product-img').innerHTML = "";
    document.getElementById('banner-image').value = '';
}

function restoreStablisments() {
    const stateSelect = document.getElementById('ddlState');
    const citySelect = document.getElementById('ddlCity');
    const stablishSelect = document.getElementById('divEstablishment');
    const clear = [
        stateSelect,
        citySelect,
        stablishSelect
    ]
    clear.forEach(element => {
        element.selectedIndex = 0;
        if (element.id === "ddlCity" || element.id === "divEstablishment") {
            element.style = "display: none"
        }
    })
}


document.querySelectorAll('input[name="rbBannerType"]').forEach((element) => {
    element.addEventListener('change', function (e) {
        restoreForm();
        document.getElementById('bannerContainer').innerHTML = '';
        document.getElementById('div-banners-added').style = "display:none";

        if (this.value == "establishment") {
            document.getElementById('divEstablishments').style.display = "block";
            document.getElementById('divPromo').style.display = "none";

            document.getElementById('txtBannerTitle').value = "";
            document.getElementById('txtBannerURL').value = "";

            loadStates();
        }
        else {
            document.getElementById('divPromo').style.display = "block";
            document.getElementById('divEstablishments').style.display = "none";
            document.getElementById('divCity').style.display = "none";
            document.getElementById('divEstablishment').style.display = "none";

            ddlCities.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';
            ddlEstablishments.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';

            loadBanners(false);
        }
    })
});

function previewPicture(e) {
    document.querySelector('.alerts-container').innerHTML = '';
    url_picture = null;

    let outPut = document.querySelector('.menu-product-img');
    outPut.innerHTML = "";
    let outPutImage = document.createElement("img");
    outPutImage.src = URL.createObjectURL(e.target.files[0]);

    outPutImage.onload = function () {
        URL.revokeObjectURL(outPutImage.src) // free memory

        if (this.width >= 500 && this.height >= 500) {
            if (e.target.files[0].size < 4096000)
                outPut.appendChild(outPutImage);
            else {
                alert('Por favor, seleccione una imagen de menos de 4MB.', 'error');
                e.target.value = "";
            }
        }
        else {
            alert('Por favor, seleccione una imagen de al menos 500x500 pixeles.', 'error');
            e.target.value = "";
        }
    }
}

UI.showLoader();

function loadPage() {
    if ((localStorage.getItem('user_type') || "") != "1") {
        location.href = "index.html";
    }
    else {
        getStates();
    }
}

function getStates() {
    fetch(
        BASE_URLS.Dinny.api + `/states/list?req_id=${new Date().getTime()}`,
        {
            credentials: 'include'
        }
    ).then(function (response) {
        if (response.ok) {
            UI.hideLoader();
            response.json().then(function (json) {
                console.log(json);
                objGeneralInfo = json;
                loadStates();
            });
        } else {
            response.json().then(function (content) {
                if (403 == response.status) {
                    window.location.href = 'login.html'
                } else {
                    UI.hideLoader();
                    alert("Ocurrió un error al cargar los banners.", 'error')
                }
            })
        }
    }).catch(function () { UI.hideLoader() });
}

function loadStates() {
    if (objGeneralInfo != null) {
        ddlStates.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';
        objGeneralInfo.forEach((element) => {
            ddlStates.insertAdjacentHTML('beforeend', '<option value="' + element.state_id + '">' + element.state_name + '</option>');
        });
    }
}

function loadCities(stateId) {
    if (objGeneralInfo != null) {
        objStateInfo = objGeneralInfo.find(x => x.state_id == stateId);
        if (objStateInfo) {
            ddlCities.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';
            objStateInfo.cities.forEach((element) => {
                ddlCities.insertAdjacentHTML('beforeend', '<option value="' + element.name + '">' + element.name + '</option>');
            });
        }
    }
}

function loadEstablishments(cityId) {
    if (objStateInfo != null) {
        objCityInfo = objStateInfo.cities.find(x => x.name == cityId);
        if (objCityInfo) {
            ddlEstablishments.innerHTML = '<option value="" hidden="" selected="">Selecciona una opción</option>';
            objCityInfo.stores.forEach((element) => {
                ddlEstablishments.insertAdjacentHTML('beforeend', '<option value="' + element.id + '">' + element.name + '</option>');
            });
        }
    }
}

function loadBanners(isEstablishment) {
    document.getElementById('bannerContainer').innerHTML = '';
    document.getElementById('div-banners-added').style = "display:none";

    //get state and city banners
    if (!isEstablishment || (ddlStates.value != "" && ddlCities.value != "")) {
        fetch(
            BASE_URLS.Dinny.no_cms + `/ad-banner?state_id=${ddlStates.value}&city=${encodeURIComponent(ddlCities.value.trim().toLowerCase().replace(/\s/g, '_'))}&req_id=${new Date().getTime()}`,
            {
                credentials: 'include'
            }
        ).then(function (response) {
            if (response.ok) {
                UI.hideLoader();
                response.json().then(function (json) {
                    console.log(json);

                    let showDivBannersAdded = false;
                    for (let idx = 0; idx < json.length; idx++) {
                        let objBanner = json[idx];

                        if ((isEstablishment && objBanner.type == "promo") || (!isEstablishment && objBanner.type == "establishment"))
                            continue;

                        let titleBanner = objBanner.title || "";
                        if (isEstablishment) {
                            let objEstablishment = objCityInfo.stores.find(x => x.id == objBanner.content);
                            if (objEstablishment)
                                titleBanner = objEstablishment.name;
                            else
                                continue;
                        }

                        showDivBannersAdded = true;
                        document.getElementById('bannerContainer').insertAdjacentHTML(
                            'beforeend',
                            layoutCard
                                .replace(/{URL-IMG-BANNER}/ig, objBanner.image)
                                .replace(/{TITLE-BANNER}/ig, titleBanner)
                                .replace(/{URL-BANNER}/ig, objBanner.url)
                                .replace(/{ID-BANNER}/ig, objBanner.id)
                                .replace(/{TYPE-BANNER}/ig, objBanner.type)
                                .replace(/{CONTENT-BANNER}/ig, objBanner.content)
                                .replace(/{PICTURE-BANNER}/ig, objBanner.image)
                        );
                    }

                    if (showDivBannersAdded)
                        document.getElementById('div-banners-added').style = "display:grid";
                });
            } else {
                response.json().then(function (content) {
                    if (403 == response.status) {
                        window.location.href = 'login.html'
                    } else {
                        UI.hideLoader();
                        alert("Ocurrió un error al cargar los banners.", 'error')
                    }
                })
            }
        }).catch(function () { UI.hideLoader() });
    }
}

btnSave.addEventListener('click', function (e) {
    document.querySelector('.alerts-container').innerHTML = '';
    let bannerType = document.querySelector('input[name="rbBannerType"]:checked').value;
    let bannerState = ddlStates.value;
    let bannerCity = ddlCities.value;
    let bannerEstablishment = ddlEstablishments.value;
    let bannerURL = document.getElementById('txtBannerURL').value.trim();
    let bannerTitle = document.getElementById('txtBannerTitle').value.trim();
    let bannerImage = document.getElementById('banner-image').files[0];
    let isAdd = btnSave.innerText.toLowerCase().indexOf("generar") != -1;

    if (bannerType.length != 0) {
        if (bannerType == "establishment") {
            if (bannerEstablishment == "") {
                alert("Seleccione un establecimiento.", 'error');
                return;
            }
            else if (isAdd) {
                //Search if a banner for this establishment has already been added
                let objBannerAdded = document.querySelector('span.icon-edit[data-content="' + bannerEstablishment + '"]');
                if (objBannerAdded) {
                    alert("Ya se ha generado previamente un banner para el establecimiento seleccionado.", 'error');
                    return;
                }
            }
        }

        if (bannerType == "promo" && bannerTitle.length == 0) {
            alert("Escriba el título del banner.", 'error');
            return;
        }

        if (bannerType == "promo" && /[\[\]{}~¨°\|\\\^]/.test(bannerTitle)) {
            alert("El título del banner contiene caracteres no permitidos.", 'error');
            return;
        }

        if (bannerType == "promo" && bannerTitle.length > 50) {
            alert("El título del banner es demasiado largo.", 'error');
            return;
        }

        if (bannerType == "promo" && bannerURL.length == 0) {
            alert("Escriba el link del banner.", 'error');
            return;
        }

        if (bannerType == "promo" && bannerURL.length > 256) {
            alert("El link del banner es demasiado largo.", 'error');
            return;
        }

        if (bannerType != "establishment" && !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(bannerURL)) {
            alert("El link del banner no es una URL válida.", 'error');
            return;
        }

        if (isAdd && (bannerImage == null || bannerImage === "undefined")) {
            alert('Seleccione una imagen para el banner.', 'error');
            return;
        }

        if (!isAdd && bannerType == "establishment" && (bannerImage == null || bannerImage === "undefined")) {
            alert('Seleccione una imagen para el banner.', 'error');
            return;
        }

        let objBanner = {
            id: isAdd ? "0" : btnSave.dataset.id,
            type: bannerType,
            is_active: true,
            city: bannerType == "establishment" ? bannerCity : "",
            state_id: bannerType == "establishment" ? bannerState : "",
            state_name: bannerType == "establishment" ? ddlStates.options[ddlStates.selectedIndex].text : "",
            content: bannerType == "establishment" ? bannerEstablishment : bannerURL,
            image: url_picture,
            url: bannerURL,
            title: bannerTitle
        };

        if (isAdd)
            delete objBanner.id;

        if (bannerType == "establishment")
            delete objBanner.url;

        UI.showLoader();

        if (bannerImage != null && bannerImage !== "undefined") {
            //Guardar imagen...
            let objReader = new FileReader();
            objReader.readAsDataURL(bannerImage);
            objReader.onload = function (e) {
                let base64string = e.target.result;
                base64string = base64string.replace(base64string.substring(0, base64string.indexOf(',') + 1), "");

                fetch(
                    BASE_URLS.Standalone.api + '/picture',
                    {
                        method: 'POST',
                        body: JSON.stringify({
                            key: 'image/ad-banners/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + bannerImage.name.split('.').pop(),
                            content: base64string,
                            contentType: bannerImage.type
                        }),
                        credentials: 'include'
                    }).then(function (response) {
                        if (response.ok) {
                            response.json().then(function (picture_url) {
                                objBanner.image = picture_url;

                                if (isAdd)
                                    addBanner(objBanner);
                                else
                                    updateBanner(objBanner);
                            });
                        } else {
                            response.json().then(function (content) {
                                if (403 == response.status) {
                                    window.location.href = 'login.html'
                                } else {
                                    UI.hideLoader();
                                    alert('Ocurrió un error al guardar la imagen.', 'error');
                                }
                            });
                        }
                    }).catch(function (e) {
                        UI.hideLoader();
                        alert('Ocurrió un error al guardar la imagen.', 'error');
                        console.log(e);
                    });
            };

        }
        else {
            updateBanner(objBanner);
        }
    }
    else {
        alert("Seleccione un tipo de banner.", 'error');
    }
});

function addBanner(objBanner) {
    fetch(
        BASE_URLS.Dinny.no_cms + '/ad-banner',
        {
            method: 'POST',
            body: JSON.stringify(objBanner),
            credentials: 'include'
        }).then(function (response) {
            if (response.ok) {
                UI.message({ title: 'Datos guardados', content: "Se ha generado el banner.", accept: 'Aceptar' });
                UI.hideLoader();


                document.querySelector('.menu-product-img').innerHTML = '';
                document.getElementById('banner-image').value = '';
                document.getElementById('txtBannerURL').value = "";
                document.getElementById('txtBannerTitle').value = "";

                loadBanners(objBanner.type == "establishment");
                restoreStablisments();
            } else {
                response.json().then(function (content) {
                    if (403 == response.status) {
                        window.location.href = 'login.html'
                    } else {
                        UI.hideLoader();
                        alert('Ocurrió un error al guardar el banner.', 'error');
                    }
                });
            }
        }).catch(function (e) {
            UI.hideLoader();
            alert('Ocurrió un error al guardar el banner.', 'error');
            console.log(e);
        });
}

function updateBanner(objBanner) {
    fetch(
        BASE_URLS.Dinny.no_cms + '/ad-banner/' + objBanner.id + '?req_id=' + new Date().getTime(),
        {
            method: 'PUT',
            body: JSON.stringify(objBanner),
            credentials: 'include'
        }).then(function (response) {
            if (response.ok) {
                UI.message({ title: 'Datos guardados', content: "Se ha actualizado el banner.", accept: 'Aceptar' });
                UI.hideLoader();

                restoreForm();
                document.getElementById('txtBannerURL').value = "";
                document.getElementById('txtBannerTitle').value = "";

                loadBanners(objBanner.type == "establishment");
            } else {
                response.json().then(function (content) {
                    if (403 == response.status) {
                        window.location.href = 'login.html'
                    } else {
                        UI.hideLoader();
                        alert('Ocurrió un error al guardar el banner.', 'error');
                    }
                });
            }
        }).catch(function (e) {
            UI.hideLoader();
            alert('Ocurrió un error al guardar el banner.', 'error');
            console.log(e);
        });
}

function deleteBanner(element) {
    UI.confirm({
        title: 'Eliminar banner',
        content: '¿Estás seguro de eliminar el banner <b>' + element.dataset.title + '</b>?',
        cancel: 'No',
        accept: 'Sí'
    }, function (response) {
        if (response) {
            UI.showLoader();
            fetch(
                BASE_URLS.Dinny.no_cms + '/ad-banner/' + element.dataset.id + '?req_id=' + new Date().getTime(),
                {
                    method: 'DELETE',
                    credentials: 'include'
                }
            ).then(function (response) {
                if (response.ok) {
                    UI.hideLoader();
                    UI.message({ title: 'Banner eliminado', content: "Se ha eliminado el banner.", accept: 'Aceptar' });
                    element.closest('div.banner-item').remove();
                    restoreForm();
                }
                else {
                    response.json().then(function (content) {
                        if (403 == response.status) {
                            window.location.href = 'login.html'
                        } else {
                            UI.hideLoader();
                            alert('Ocurrió un error al eliminar el banner.', 'error');
                        }
                    });
                }
            }).catch(function (e) {
                UI.hideLoader();
                console.log(e)
                alert('Ocurrió un error al eliminar el banner.', 'error');
            });
        }
    });
}

function editBanner(element) {
    // Actualizar botón de registro
    btnSave.dataset.id = element.dataset.id;
    btnSave.innerText = "Actualizar banner";

    btnCancelSave.classList.remove('hide')

    url_picture = element.dataset.picture;
    document.querySelector('.menu-product-img').innerHTML = "<img src='" + url_picture + "' />";
    document.getElementById('banner-image').value = '';

    if (element.dataset.type == "establishment") {
        ddlEstablishments.value = element.dataset.content;
    }
    else {
        document.getElementById('banner-url').style = "display:flex";
        document.getElementById('txtBannerURL').value = element.dataset.content;
        document.getElementById('txtBannerTitle').value = element.dataset.title;
    }
}

btnCancelSave.addEventListener('click', function(e){
    window.location.reload()
})